



















import { computed, defineComponent } from "@vue/composition-api";
import { Location } from "vue-router";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import { timeAgo } from "@/lib/time";
import { getProfileUrl } from "@/lib/urlHelpers";
import { resolveUserName } from "@/lib/userHelpers";
import BaseAvatar from "@/components/BaseAvatar";
import ListItem from "@/components/ListItem";

export default defineComponent({
  name: "NotificationItemView",
  components: { ListItem, BaseAvatar },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
  setup(props) {
    const userName = computed<string>(() => {
      return resolveUserName(props.notification.user);
    });
    const timeText = computed<string>(() => {
      return timeAgo(props.notification.time, { addSuffix: true });
    });
    const userProfileUrl = computed<Location>(() => {
      return (props.notification.user && getProfileUrl(props.notification.user)) || {};
    });

    return {
      userName,
      timeText,
      userProfileUrl,
    };
  },
});
